:root {
  color-scheme: light dark;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/*
 * Registrations, ICAO codes and counter readings are read down a column, so they use tabular
 * figures wherever they appear.
 */
.identifier,
[data-identifier] {
  font-family: var(--mantine-font-family-monospace);
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
}

/* The PIC name is already stored in capitals; do not force the whole cell to uppercase
 * because the other people on the flight sit in the same column in title case. */
.pic-name {
  font-weight: 600;
  letter-spacing: 0.03em;
}

/* Logbook and maintenance grids are dense: keep numeric columns aligned and compact. */
.numeric-cell {
  font-variant-numeric: tabular-nums;
  text-align: right;
}

/* TipTap placeholder, shown when a maintenance note is still empty. */
.mantine-RichTextEditor-content .ProseMirror p.is-editor-empty:first-child::before {
  content: attr(data-placeholder);
  float: left;
  height: 0;
  pointer-events: none;
  color: var(--mantine-color-placeholder);
}

@media print {
  /* Printing a logbook page should give the table, not the application around it. */
  .mantine-AppShell-header,
  .mantine-AppShell-navbar,
  .no-print {
    display: none !important;
  }

  .mantine-AppShell-main {
    padding: 0 !important;
  }
}
